/** =========================================================
 * Module: items-table.directive.js
 * Data table
 *
 * Config scheme
 *  {
 *      model: String,
 *      ?getData: Promise(model, getDataParams),
 *      getDataParams: { order: {}, search: String, page: Integer }
 *      fields: [
 *          {
 *              title: String,
 *              key: String,
 *              ?order: Bool,
 *              ?filters: ['translate', 'capitalize', 'replace_'],
 *              ?value: Function(item)
 *              ?customType: ['date', 'datetime', 'html'],
 *              ?minWidth: Number
 *          }
 *      ],
 *      ?add: {
 *          permission: Bool,
 *          template: String,
 *          ?wide: Bool,
 *          ?except: [],
 *          ?only: [],
 *          ?before: Promise(item),
 *          ?success: Promise(response, item)
 *      },
 *      ?edit: {
 *          permission: Bool,
 *          template: String,
 *          ?wide: Bool,
 *          ?except: [],
 *          ?only: [],
 *          ?before: Promise(item),
 *          ?success: Promise(response, item)
 *      },
 *      ?delete: {
 *          permission: Bool,
 *          ?before: Promise(item),
 *          ?success: Promise(response, item)
 *      },
 *      ?linkButtons: [
 *          {
 *              title: String,
 *              action: Function(item),
 *              icon: String,
 *              class: String,
 *              permission: Bool,
 *              ?visible: Function(item),
 *              ?text: Function || String
 *          }
 *      ],
 *      ?customButtons: [
 *          {
 *              title: String,
 *              action: Function(item),
 *              icon: String,
 *              class: String,
 *              permission: Bool,
 *              ?visible: Function(item),
 *              ?text: Function || String
 *          }
 *      ]
 *  }
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemsTable', itemsTable);

  itemsTable.$inject = ['$rootScope', '$api', '$translate'];

  function itemsTable($rootScope, $api, $translate) {
    var directive = {
      restrict: 'AE',
      templateUrl: 'app/views/components/items-table.html',
      link: link,
      scope: {
        config: '=',
        items: '=?'
      }
    };

    return directive;

    function link($scope) {
      if ($scope.config) {
        $scope.getButtonsWidth = function () {
          var value = 16;

          if ($scope.config.edit) {
            value += 34;
          }

          if ($scope.config.delete) {
            value += 34;
          }

          if ($scope.config.edit && $scope.config.delete) {
            value += 4;
          }

          if ($scope.config.customButtons) {
            value += (38 * $scope.config.customButtons.length);
          }

          return value;
        };

        $scope.getValue = function (item, field) {
          try {
            var value = field.value ? field.value(item) : item[field.key];

            // Apply filters
            if (typeof field.filters === 'object') {
              field.filters.forEach(function (filter) {
                switch (filter) {
                case 'translate':
                  value = $translate.instant(value);
                  break;
                case 'capitalize':
                  value = value.capitalize();
                  break;
                case 'replace_':
                  value = value._replace();
                  break;
                default:
                }
              });
            }

            return value;
          } catch (error) {
            Raven.captureException(error);
          }

          return '';
        };

        $scope.getDate = function (item, field) {
          try {
            var format = field.customType === 'date' ? $rootScope.appConfig.dateFormat : $rootScope.appConfig.dateTimeFormat;

            var value = $scope.getValue(item, field);

            return value ? moment(value).format(format) : '';
          } catch (error) {
            Raven.captureException(error);
          }

          return '';
        };

        $scope.getHumanDate = function (item, field) {
          try {
            var value = $scope.getValue(item, field);

            return value ? moment(value).fromNow() : '';
          } catch (error) {
            Raven.captureException(error);
          }

          return '';
        };

        if ($scope.config.model && $scope.config.getData && $scope.config.getDataParams) {
          $scope.reorder = function (field) {
            try {
              var type;
              var data = {};

              if (field.order) {
                type = 'order';
                delete $scope.config.getDataParams.sort;
              }

              if (field.sort) {
                type = 'sort';
                delete $scope.config.getDataParams.order;
              }

              data[field.key] = 'asc';

              if (!$scope.config.getDataParams[type]) {
                $scope.config.getDataParams[type] = data;
              } else if (typeof $scope.config.getDataParams[type][field.key] === 'undefined') {
                $scope.config.getDataParams[type] = data;
              } else if ($scope.config.getDataParams[type][field.key] === 'asc') {
                $scope.config.getDataParams[type][field.key] = 'desc';
              } else {
                $scope.config.getDataParams[type][field.key] = 'asc';
              }

              $scope.config.getDataParams.page = 1;
              $scope.config.getData();
            } catch (error) {
              Raven.captureException(error);
            }
          };
        }
      }
    }
  }
})();
